/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Final_SubInputs */

const en_cp_final_sub = /** @type {(inputs: Cp_Final_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send an application today; a kickoff can be scheduled within two weeks.`)
};

const id_cp_final_sub = /** @type {(inputs: Cp_Final_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim pengajuan hari ini; kickoff bisa dijadwalkan dalam dua minggu.`)
};

/**
* | output |
* | --- |
* | "Send an application today; a kickoff can be scheduled within two weeks." |
*
* @param {Cp_Final_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_final_sub = /** @type {((inputs?: Cp_Final_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Final_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_final_sub(inputs)
	return en_cp_final_sub(inputs)
});